import { ColumnDef } from "@tanstack/react-table";
import React from "react";
import { Link } from "react-router-dom";
import { StatisticsTrackItem } from "../../../api/useMusicApi";
import { TableRenderUtils } from "../../../components/Table/TableRenderUtils";
import { TFunction } from "i18next";
import { truncate } from "../../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMusic } from "@fortawesome/free-solid-svg-icons/faMusic";
import { faCompactDisc } from "@fortawesome/free-solid-svg-icons/faCompactDisc";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { faEye } from "@fortawesome/free-solid-svg-icons/faEye";
import { faHashtag } from "@fortawesome/free-solid-svg-icons/faHashtag";

export function statisticsTopsColumnsDefinition(
  t: TFunction,
  needShowRowIndex: boolean = false,
): Array<ColumnDef<StatisticsTrackItem, any>> {
  const columns: Array<ColumnDef<StatisticsTrackItem, any>> = [
    {
      id: "Image",
      header: () => <></>,
      size: 45,
      enableSorting: false,
      accessorFn: (value) => value.album_image_url,
      cell: (value) => {
        const url = value.getValue()
          ? value.getValue().replace("{}", "medium")
          : "/album_cover_default_150x150.jpg";
        return TableRenderUtils.renderBaseContent(
          <img
            height={45}
            width={45}
            className={"border rounded"}
            src={url}
            alt={"ap"}
          />,
        );
      },
    },
    {
      id: "Album",
      header: () => (
        <>
          <FontAwesomeIcon icon={faCompactDisc} /> {t("album")}
        </>
      ),
      size: 300,
      enableSorting: false,
      accessorFn: (value) => value.album_title,
      cell: (value) => {
        if (!value.row.original.is_mine) {
          {
            return TableRenderUtils.renderBaseContent(value.getValue());
          }
        }

        return TableRenderUtils.renderBaseContent(
          <Link
            to={`/statistics/${value.row.original.album_id}/${value.row.original.track_id}`}
            className={"dark:text-white"}
          >
            {value.getValue()}
          </Link>,
        );
      },
    },
    {
      id: "Track",
      header: () => (
        <>
          <FontAwesomeIcon icon={faMusic} /> {t("track")}
        </>
      ),
      size: 300,
      enableSorting: false,
      accessorFn: (value) => value.track_title,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(
          truncate(value.getValue(), 80),
        );
      },
    },
    {
      id: "Artist",
      header: () => (
        <>
          <FontAwesomeIcon icon={faUser} /> {t("artist")}
        </>
      ),
      enableSorting: false,
      accessorFn: (value) => value.artist_name,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(
          <div className={"flex text-wrap"}>
            {truncate(value.getValue(), 50)}
          </div>,
        );
      },
    },
    {
      id: "Streams",
      header: () => (
        <>
          <FontAwesomeIcon icon={faEye} /> {t("streams")}
        </>
      ),
      enableSorting: false,
      accessorFn: (value) => value.streams,
      cell: (value) => {
        const formatter = new Intl.NumberFormat("ru-RU", {
          useGrouping: true,
        });
        return TableRenderUtils.renderBaseContent(
          <>{value.getValue() ? formatter.format(value.getValue()) : "--"}</>,
        );
      },
    },
  ];

  if (needShowRowIndex) {
    columns.unshift({
      id: "Index",
      header: () => (
        <>
          <FontAwesomeIcon icon={faHashtag} />
        </>
      ),
      size: 20,
      enableSorting: false,
      accessorFn: (value) => value.streams,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(
          <span className={"font-bold"}>{value.row.index + 1}</span>,
        );
      },
    });
  }
  return columns;
}
